import { api } from './index';
import { omitBy } from 'lodash';
import { isNil } from 'utils';

export default {
  getProductSectionList() {
    const params = {};
    return api.get('product_sections', { params: omitBy(params, isNil) });
  },
  getProductSectionDetail(id) {
    return api.get(`product_sections/${id}`);
  },
  createProductSection(payload) {
    return api.post('product_sections', payload);
  },
  updateProductSection(id, payload) {
    return api.put(`product_sections/${id}`, payload);
  },
  deleteProductSection(id) {
    return api.delete(`product_sections/${id}/delete`);
  },
  reactivateProductSection(id) {
    return api.put(`product_sections/${id}/reactivate`);
  },
  deactivateProductSection(id) {
    return api.delete(`product_sections/${id}`);
  },
};
